import { CTAButton } from "./CTAButton";
import { CHECKOUT_URL } from "../../lib/assets";

const steps = [
  {
    title: "Press record.",
    body: "From your car, your closet, your bed… Wherever you are, whatever's alive for you. That's where we start.",
  },
  {
    title: "I'm responding within 24 hours.",
    body: "Monday through Friday for six months straight.",
  },
  {
    title: "I'm tracking the whole picture.",
    body: "The patterns. The frequency. The cobwebs. The belief that's talking you out of your own momentum. I see it and I name it with love and care, every time.",
  },
  {
    title: "You take action in a slow, regulated way.",
    body: "Because you stopped working against yourself. Your instincts get clear. You trust them. You go.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      className="relative py-28 md:py-40"
      data-testid="how-it-works-section"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-20 md:mb-28">
          <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-6">
            How it works&hellip;
          </p>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-light leading-[1.05] tracking-tight text-[#3B2630] max-w-4xl mx-auto">
            Your voice in my ear,
            <span className="block italic text-[#C9587E] mt-2">
              and mine in yours.
            </span>
          </h2>
        </div>

        <div className="space-y-8 md:space-y-10">
          {steps.map((it, idx) => (
            <div
              key={it.title}
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-12 items-start rounded-2xl border border-[#3B2630]/10 bg-[#FFFCFB] p-8 md:p-10 shadow-ambient"
              data-testid={`hiw-item-${idx}`}
            >
              <div className="md:col-span-2">
                <span className="font-serif text-3xl md:text-4xl font-light text-[#C9587E]">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="md:col-span-10 max-w-2xl">
                <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl font-light text-[#3B2630] tracking-tight mb-4 leading-snug">
                  {it.title}
                </h3>
                <p className="font-body text-base md:text-lg text-[#6B5058] leading-relaxed">
                  {it.body}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <CTAButton variant="secondary" href={CHECKOUT_URL} testid="hiw-cta">
            Nuff Said.
          </CTAButton>
        </div>
      </div>
    </section>
  );
};
